var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEachhitterIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.438,
    height: 16.949,
    viewBox: "0 0 19.438 16.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5BB9",
    "data-name": "\\u5167\\u5BB9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.938,16.949H.5c-.179,0-.344-.095-.433-.25s-.089-.345,0-.5L9.286,.232c.179-.31,.688-.31,.866,0l9.219,15.967c.089,.155,.089,.345,0,.5s-.254,.25-.433,.25ZM1.366,15.949H18.071L9.719,1.482,1.366,15.949Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEachhitterIcon3);
export default __webpack_public_path__ + "static/media/eachhitter_icon3.ce0e8da4922b4634681965939a6cf5ea.svg";
export { ForwardRef as ReactComponent };